import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export const EditBookmark = ({ bookmark }) => {
	const { title, description } = bookmark;

	return (
		<Stack
			p={2}
			spacing={2}>
			<FormControl>
				<TextField
					label="Title"
					value={title}
				/>
			</FormControl>
			<FormControl>
				<TextField
					multiline
					minRows={3}
					label="Description"
					value={description}
				/>
			</FormControl>
			<FormControl>
				<FormControlLabel
					control={<Switch />}
					label="Shared bookmark"
				/>
				<Typography
					color="text.secondary"
					variant="caption">
					Shared bookmarks are available to all map users.
				</Typography>
			</FormControl>
		</Stack>
	);
};
